const names = new WeakMap<Blob, string>();

export function rememberRecordingName(blob: Blob, name: string) {
  names.set(blob, name);
}

export function recordingDownloadName(blob: Blob): string | undefined {
  return names.get(blob);
}

export function recordingSaveName(header: string | null): string | null {
  if (header === null || header.length === 0 || /[\r\n]/.test(header)) return null;
  const star = /filename\*=UTF-8''([^;\s]+)/i.exec(header);
  if (star) {
    try {
      const decoded = decodeURIComponent(star[1]);
      return safe(decoded) ? decoded : null;
    } catch {
      return null;
    }
  }
  const plain = /filename="([^"]*)"/.exec(header);
  if (!plain || !safe(plain[1])) return null;
  return plain[1];
}

function safe(name: string): boolean {
  return name.length > 0 && name.length <= 180 && /^[A-Za-z0-9._-]+$/.test(name);
}
